import { render, staticRenderFns } from "./BodyDataItem.vue?vue&type=template&id=8869c5ea&scoped=true&"
import script from "./BodyDataItem.vue?vue&type=script&lang=js&"
export * from "./BodyDataItem.vue?vue&type=script&lang=js&"
import style0 from "./BodyDataItem.vue?vue&type=style&index=0&id=8869c5ea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8869c5ea",
  null
  
)

export default component.exports